import { useState, useEffect, Key } from "react";
import { Link } from "react-router-dom";
import Icon from "@mui/material/Icon";
import Container from "@mui/material/Container";
import { Box } from "@mui/material";
import SoftBox from "components/SoftBox";
import DefaultNavbarLink from "./DefaultNavbarLink";
import DefaultNavbarMobile from "./DefaultNavbarMobile";
import breakpoints from "../../../assets/theme/base/breakpoints";
import AllPages from "examples/ReuseFunctions/AllPages";

function DefaultNavbar({ transparent = false, light = false, action = false }) {
  // Use HTMLElement | null instead of boolean
  const [mobileNavbarAnchor, setMobileNavbarAnchor] =
    useState<HTMLElement | null>(null);
  const [mobileView, setMobileView] = useState(false);

  const openMobileNavbar = (event: React.MouseEvent<HTMLElement>) => {
    setMobileNavbarAnchor(event.currentTarget); // store the element
  };
  const closeMobileNavbar = () => setMobileNavbarAnchor(null); // close by null

  useEffect(() => {
    function displayMobileNavbar() {
      if (window.innerWidth < breakpoints.values.xl) {
        setMobileView(true);
        setMobileNavbarAnchor(null);
      } else {
        setMobileView(false);
        setMobileNavbarAnchor(null);
      }
    }
    window.addEventListener("resize", displayMobileNavbar);
    displayMobileNavbar();
    return () => window.removeEventListener("resize", displayMobileNavbar);
  }, []);

  const { pagesData: rawPagesData, logo } = AllPages();
  const pagesData = rawPagesData ?? []; // default to empty array if null

  return (
    <Box className="default-header">
      <Container>
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <SoftBox className="logo" component={Link} lineHeight={1}>
            <img
              src={
                logo
                  ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${logo}`
                  : "../../../assets/images/scoutlogo.png"
              }
              alt="logo"
            />
          </SoftBox>

          {/* Desktop links */}
          <SoftBox
            color="inherit"
            display={{ xs: "none", lg: "flex" }}
            m={0}
            p={0}
          >
            {pagesData?.map(
              (data: {
                page_route: Key | null | undefined;
                page_name: string;
              }) => (
                <DefaultNavbarLink
                  key={data.page_route}
                  icon="info"
                  name={data.page_name}
                  route={`/${data.page_route}`}
                  light={light}
                />
              )
            )}
            <DefaultNavbarLink
              icon="info"
              name="About us"
              route="/about"
              light={light}
            />
            <DefaultNavbarLink
              icon="contacts"
              name="Contact us"
              route="/contact"
              light={light}
            />
            <DefaultNavbarLink
              icon="account_circle"
              name="Employee sign in"
              route="/employee/sign-in"
              light={light}
            />
          </SoftBox>

          {/* Mobile menu icon */}
          <SoftBox
            display={{ xs: "inline-block", lg: "none" }}
            lineHeight={0}
            py={1.5}
            pl={1.5}
            color="inherit"
            sx={{ cursor: "pointer" }}
            onClick={openMobileNavbar}
          >
            <Icon fontSize="medium">
              {mobileNavbarAnchor ? "close" : "menu"}
            </Icon>
          </SoftBox>
        </SoftBox>

        {/* Mobile menu */}
        {mobileView && (
          <DefaultNavbarMobile
            open={mobileNavbarAnchor}
            close={closeMobileNavbar}
            pagesData={pagesData}
          />
        )}
      </Container>
    </Box>
  );
}

export default DefaultNavbar;
